<template>
    <tr>
        <td>{{ money(rollover.budget) }}</td>
        <td>{{ money(rollover.spend) }}</td>
        <td>{{ money(rollover.rollover) }}</td>
        <td>
            <btn :click="apply">Maked applied</btn>
        </td>
    </tr>
</template>

<script>
export default {
    props: [
        'rollover'
    ],
    data() {
        return {
        };
    },
    methods: {
        apply() {
            return axios.post(url(`admin/budget-rollover/apply`), {
                'id': this.rollover.id
            }).then(() => {
                this.$emit('updated');
            });
        }
    }
}
</script>
